import { CSSProperties } from 'react';

export const LABEL_COL = 3;
export const LABEL_COL_MODAL = 4;

export const SUGGESTIONS_POSTE = [
    'Coordonnateur des loisir',
    'Directeur',
    'Directeur adjoint',
    'Directrice',
    'Directrice adjointe',
    'Directrice des loisirs',
    'Enseignant',
    "Enseignant d'éducation physique",
    'Enseignante',
    "Enseignante d'éducation physique",
    'Éducateur',
    'Éducatrice',
    'Éducatrice classe principale',
    'Responsable SDG',
    'Secrétaire',
    'Service de garde',
    'TES',
    'Technicien en loisirs',
    'Technicienne en Loisirs',
];

export const SUGGESTIONS_CONTEXTE = [
    'Journée pédagogique',
    'Parascolaire',
    'Fête de classe',
    'Livraison',
    'Camp de jour',
    'Autobus',
    'Semaine des services de garde',
];

export const SUGGESTIONS_CONDITION = [
    "Pédagogique pédagogique flottante. Risques d'annulations plus élevés.",
    "L'activité est conditionnelle à l'acceptation par le conseil d'établissement de l'école.",
];

export const SUGGESTIONS_LIEU = ['Pavillon principal', 'Bureau'];

export const cssTexte: CSSProperties = {
    fontSize: '0.875rem',
};

export const GROUPES_AGES = ['Maternelle à 6e année', 'Maternelle à 2e année', '3e à 6e année'];
